import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';
import type { FilterParams } from '@core/Entities/Search/QueryParams.entity';

export const getPageFiltersFromRoot = (root: PlpRoot | undefined) => {
  let pageFilters: FilterParams = {};

  switch (root) {
    case 'used':
      pageFilters = { 'stock-condition': 'used' };
      break;
    case 'new':
      pageFilters = { 'stock-condition': 'new' };
      break;
    case 'lease-deals':
      pageFilters = { 'finance-product': 'ctp' };
      break;
    default:
      break;
  }

  return pageFilters;
};
